import logger from './server'

module.exports = logger
